import {
  Box,
  BoxProps,
  ButtonNew,
  CheckBox,
  ColorOptions,
  convertHexToRGBA,
  Image,
  SpacerNew,
  Text,
  TextProps,
} from '@jfs/ui-new'

import { useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Linking } from 'react-native'
import { useLazyApiData, useStores } from '../../data/store'
import { APIEndPoints } from '../../network/APIEndpoints'
import { Colors } from '../../util/util'

export const KYCConsentScreen = () => {
  const { updateKycConsentAsync } = useStores((root) => ({
    updateKycConsentAsync: root?.user?.updateKycConsentAsync,
  }))

  const [lazyUpdateKycConsentAsync, updateKycConsentHandler] = useLazyApiData(updateKycConsentAsync)

  const [isTncAccepted, setIsTncAccepted] = useState(false)
  const navigation = useNavigation()

  useEffect(() => {
    if (updateKycConsentHandler?.state === 'fulfilled') {
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'dashboard' as never,
          },
        ],
      })
    }
  }, [updateKycConsentHandler?.state])

  const onContinuePress = () => {
    lazyUpdateKycConsentAsync()
  }

  return (
    <Box {...styles.container}>
      <Box {...styles.header}>
        <Text {...styles.headerText}>KYC Consent</Text>
      </Box>

      <Box {...styles.contentContainer}>
        <Box alignSelf={'center'}>
          <Image source={require('../../assets/images/ic_shield.png')} width={72} height={72} />
        </Box>
        <SpacerNew size={24} />
        <Text fontFamily="JioType-Medium" fontSize={20} textAlign="center">
          KYC Consent Required
        </Text>

        <Box {...styles.detailsContainer}>
          <Text {...styles.detailsText}>
            By ticking this checkbox, I expressly consent to Jio Payment Solutions Limited (“JPSL”) retrieving my/my
            entity’s KYC records and related information from the Central KYC Records Registry (“CKYCRR”) for merchant
            onboarding, KYC verification, customer due diligence, periodic KYC updation, and compliance with applicable
            legal and regulatory requirements. I understand that JPSL may retrieve such KYC records from CKYCRR, where
            required for the above purposes. I confirm that, where applicable, I am authorised to provide this consent
            on behalf of the merchant/entity.
          </Text>
        </Box>
        <Box>
          <Box height={1} backgroundColor={'BORDER_COLOR'} width={'100%'} />
          <SpacerNew size={24} />
          <Box flexDirection={'row'} alignItems={'center'} width={'100%'}>
            <CheckBox checked={isTncAccepted} iconSize={24} onChecked={setIsTncAccepted} />

            <Box flex={1} marginLeft={16}>
              <Text
                color={convertHexToRGBA(Colors.BLACK as ColorOptions, 65) as ColorOptions}
                fontFamily={'JioType-Medium'}
                fontSize={12}
                letterSpacing={-0.06}
                textAlign={'left'}>
                {'And also, I have read and agree to the  '}
                <Text
                  fontSize={12}
                  textDecorationLine="underline"
                  textDecorationStyle="solid"
                  textDecorationColor={'SECONDARY'}
                  onPress={() => Linking.openURL(APIEndPoints.tnc)}
                  color={convertHexToRGBA(Colors.SECONDARY as ColorOptions, 100) as ColorOptions}>
                  JioPay Terms and Conditions
                </Text>
              </Text>
            </Box>
          </Box>
          <SpacerNew size={24} />
        </Box>

        <ButtonNew
          title={'Continue'}
          disabled={!isTncAccepted}
          onPress={onContinuePress}
          type={'primaryFullWidth'}
          height={48}
          color={'PRIMARY'}
          hoverColor={'PRIMARY'}
          underlayColor={'PRIMARY'}
          isLoading={updateKycConsentHandler?.state === 'pending'}
        />
        <SpacerNew size={32} />
      </Box>
    </Box>
  )
}

const styles = {
  container: {
    flex: 1,
    backgroundColor: 'WHITE',
  } as BoxProps,
  header: {
    backgroundColor: 'SECONDARY',
    height: 80,
    alignItems: 'center',
    justifyContent: 'center',
  } as BoxProps,
  headerText: {
    fontSize: 20,
    fontFamily: 'JioType-Bold',
    textAlign: 'center',
    color: 'WHITE',
  } as TextProps,
  contentContainer: {
    backgroundColor: 'WHITE',
    marginTop: -16,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    ph: 16,
    pv: 24,
    flex: 1,
  } as BoxProps,
  detailsContainer: {
    backgroundColor: '#FDFCFB' as any,
    padding: 24,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: 'BORDER_COLOR',
    marginVertical: 16,
    flex: 1,
  } as BoxProps,
  detailsText: {
    fontSize: 12,
    color: '#4A3D32' as any,
    fontFamily: 'JioType-Medium',
    lineHeight: 21,
  } as TextProps,
}
